import { render, staticRenderFns } from "./NewController.vue?vue&type=template&id=652f0aa0"
import script from "./NewController.vue?vue&type=script&lang=js"
export * from "./NewController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports